module.exports = __webpack_public_path__ + "img/20200508_180551.1e251ebc.jpg";